var render, staticRenderFns
import script from "./FormAsterisk.vue?vue&type=script&lang=ts&"
export * from "./FormAsterisk.vue?vue&type=script&lang=ts&"
import style0 from "./FormAsterisk.vue?vue&type=style&index=0&id=e205c07a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports